import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_discoveryFeedsByListingId';

const query = `
    query recommendedListings($listingTriads: [String!]!, $startDate: String, $endDate: String, $size: Int, $target: PropertyTarget) {
        recommendedListings(listingTriads: $listingTriads, startDate: $startDate, endDate: $endDate, size: $size, target: $target) {
            listing {
                bedrooms
                address {
                    city
                    stateProvince
                }
                averagePrice {
                    localized
                }
                averageRating
                reviewCount
                sleeps
                thumbnailUrl
                detailPageUrl
                propertyMetadata {
                    headline
                }
                spu
            }
        }
    }`;

async function getRecommendedPropertiesGraphQl({
    listingTriads,
    startDate,
    endDate,
    size,
    target,
    fallback
}) {
    let params = {
        listingTriads,
        size,
        target
    };
    if (startDate) params = {...params, startDate};
    if (endDate) params = {...params, endDate};
    if (fallback) params = {...params, fallback};
    return graphqlQuery(OPERATION_NAME, query, params);
}

export default getRecommendedPropertiesGraphQl;
export {getRecommendedPropertiesGraphQl, OPERATION_NAME};
